import { Button, ButtonGroup, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import {
  addbank,
  resetbank,
  fetchAllbanks,
} from "../../redux/features/bank.features";
import spinner from "../../assets/Spinner-1s-200px.svg";

const initialValues = {
  bankId: "",
  bankName: "",
  bankCode: "",
  accountName: "",
  accountNo: "",
  swiftCode: "",
  bankAddress: "",
  routingNo: "",
  country: "USA",
  status: "Active",
};

const AddBank = (props) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState(initialValues);
  const [buttonClicked, setbuttonClicked] = useState(false);

  // const bankState = useSelector(state=> state.bankReducer)
  let bankState = useSelector((state) => {
    return state.bankReducer;
  });

  let { banks, loading, editbank, bankUpdated } = bankState;
  const { bankAdded } = bankState;
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setValues({
      ...values,
      [name]: value,
    });
    setbuttonClicked(false);
  };

  useEffect(() => {
    if (bankAdded) {
      dispatch(resetbank());
      alert("New Bank added successfully");
      setValues(initialValues);
      dispatch(fetchAllbanks());
      props.onClose();

    }
  }, [bankAdded]);

  const cancelbank = () => {
    setValues(initialValues);
    props.onClose();
  };

  const savebank = () => {

   
    setbuttonClicked(true);

    if (values.bankName === "")
      return alert("Cannot save bank without Bank Name");
    if (values.accountNo === "")
      return alert("Cannot save bank without Bank Account Number");

    if (window.confirm("Are you sure you want to save this bank ?")) {
      dispatch(addbank(values));
    } else {
      setbuttonClicked(false);
    }
  };

  return (
    <div className="flex  w-full flex-wrap">
      <div style={{ width: "50vw" }} className="flex  flex-col p-2">
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            label="Bank id"
            color="warning"
            name="id"
            disabled
            onChange={handleChange}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            label="Bank Name"
            placeholder="Bank of Ceylon... "
            name="bankName"
            color="warning"
            onChange={handleChange}
            value={values.bankName}
          />
          <TextField
            fullWidth
            required
            label="Account Holder Name"
            placeholder="ex: RELIANCE TRADES"
            color="warning"
            name="accountName"
            value={values.accountName}
            onChange={handleChange}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            type="number"
            label="AccountNo"
            placeholder="111-222-333-444"
            name="accountNo"
            color="warning"
            onChange={handleChange}
            value={values.accountNo}
          />
          <TextField
            fullWidth
            required
            type=""
            label="Swift Code"
            placeholder="Ex : SDFCMFGU33"
            name="swiftCode"
            color="warning"
            onChange={handleChange}
            value={values.swiftCode}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            multiline
            rows={4}
            label="Bank Address"
            placeholder="Ex : 30 W.26 STREET, SIX FLOOR, NEW YORK, NY ,10010"
            color="warning"
            name="bankAddress"
            value={values.bankAddress}
            onChange={handleChange}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <CustomSelectBox
            items={[
              "Sri Lanka",
              "Singapore",
              "Tanzania",
              "USA",
              "UK",
              "Madagascar",
              "Hong Kong",
              "China",
            ]}
            onChange={handleChange}
            title="country"
            name="country"
            value={values.country}
          />
          <TextField
            fullWidth
            required
            label="routingNo"
            placeholder="routingNo"
            name="routingNo"
            color="warning"
            onChange={handleChange}
            value={values.routingNo}
          />
        </div>
      </div>

      <div className="flex w-4/12 justify-end items-center p-2">
        <div className="flex w-full justify-evenly m-1">
          <div
            onClick={(e) => {
              cancelbank();
            }}
            className="m-1 flex w-6/12 text-white items-center font-bold justify-center uppercase text-sm bx bxs-x-square bg-red-600 cursor-pointer hover:bg-red-700 p-3"
          >
            Cancel
          </div>
          <div
            onClick={(e) => {
              savebank(e);
            }}
            className={`${
              buttonClicked ? "disabled" : ""
            }  m-1 flex w-6/12 text-white items-center font-bold justify-center uppercase text-sm bx bx-save bg-green-600 cursor-pointer hover:bg-green-700 p-3`}
          >
            Save
            {buttonClicked && (
              <img style={{ width: 50 }} src={spinner} alt="spinner"></img>
            )}
          </div>

        </div>
      </div>

      
    </div>
  );
};

export default AddBank;
